import { render } from "./GatewaysTable.vue?vue&type=template&id=3e4bcc40&scoped=true&ts=true"
import script from "./GatewaysTable.vue?vue&type=script&lang=ts"
export * from "./GatewaysTable.vue?vue&type=script&lang=ts"

import "./GatewaysTable.vue?vue&type=style&index=0&id=3e4bcc40&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e4bcc40"]])

export default __exports__